module.exports = __webpack_public_path__ + "static/media/dgi.8d1c8c1b.png";